type GameMode = 'stadium' | 'tent' | 'party' | ''

export const getGameMode = (gameCode: string): GameMode => {
  switch (gameCode.length) {
    case 4:
      return 'stadium'
    case 5:
      return 'tent'
    case 6:
      return 'party'
    default:
      return ''
  }
}

export const isEventGameCode = (gameCode: number): boolean => {
  const gameMode = getGameMode(gameCode.toString())
  return gameMode === 'stadium' || gameMode === 'tent'
}
